import Abstract from "../../../abstract-view/abstract.js";

export default class DocumentHead extends Abstract {
  constructor() {
    super();

    this._element = document.head;
  }

  getMetaTitle() {
    return this._element.querySelector(`title`);
  }

  getMetaOgTitle() {
    return this._element.querySelector(`meta[property="og:title"]`);
  }

  getMetaDescription() {
    return this._element.querySelector(`meta[name="description"]`);
  }

  getMetaOgDescription() {
    return this._element.querySelector(`meta[property="og:description"]`);
  }

  setMetaTitle(text) {
    this.getMetaTitle().textContent = text;
    this.getMetaOgTitle().content = text;
  }

  setMetaDescription(text) {
    this.getMetaDescription().content = text;
    this.getMetaOgDescription().content = text;
  }

  getMetaTitleValue() {
    return this.getMetaTitle().textContent.trim();
  }

  getMetaDescriptionValue() {
    return this.getMetaDescription().content.trim();
  }
}
